(function () {
  console.log('[EAB B2B Forms validation] Script loaded');

  var initializedForms = [];
  var observedRoots = [];
  var scheduleTimer = null;
  var messages = window.eabRegistrationTranslations || {
    contactPerson: 'Contact person',
    orgNumber: 'Enter a valid Swedish company registration number.',
    invoiceEmail: 'Enter a valid invoice email address.',
    shippingCarrier: 'Enter the shipping carrier.',
    ganNumber: 'Enter the GAN number.'
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[åä]/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getFormsEmbeds() {
    return Array.prototype.slice.call(document.querySelectorAll('form-embed, shopify-forms-embed'));
  }

  function getSearchRoots() {
    var roots = [];

    getFormsEmbeds().forEach(function (embed) {
      if (embed.shadowRoot) {
        roots.push(embed.shadowRoot);
      }

      roots.push(embed);
    });

    if (!roots.length) {
      roots.push(document);
    }

    return roots;
  }

  function query(root, selector) {
    try {
      return root.querySelector(selector);
    } catch (_) {
      return null;
    }
  }

  function queryAll(root, selector) {
    try {
      return root.querySelectorAll(selector);
    } catch (_) {
      return [];
    }
  }

  function getInputFromMatch(element) {
    if (!element) {
      return null;
    }

    if (/^(BUTTON|FIELDSET|INPUT|SELECT|TEXTAREA)$/.test(element.tagName)) {
      return element;
    }

    return query(element, 'input:not([type="hidden"]), select, textarea, button');
  }

  function getLabelledByText(field) {
    var root = field.getRootNode ? field.getRootNode() : document;
    var labelledBy = field.getAttribute('aria-labelledby');
    var text = '';

    if (!labelledBy) {
      return '';
    }

    labelledBy.split(/\s+/).forEach(function (id) {
      var label = query(root, '#' + cssEscape(id));
      if (label) {
        text += ' ' + label.textContent;
      }
    });

    return text;
  }

  function getFieldValue(field) {
    if (!field) {
      return '';
    }

    if (field.tagName === 'FIELDSET') {
      var checked = query(field, 'input[type="radio"]:checked');
      return checked ? checked.value + ' ' + checked.getAttribute('aria-label') : '';
    }

    var value = typeof field.value === 'string' ? field.value : '';

    if (field.tagName === 'SELECT' && field.selectedIndex >= 0) {
      value += ' ' + field.options[field.selectedIndex].text;
    }

    if (field.tagName === 'BUTTON') {
      value += ' ' + getLabelledByText(field) + ' ' + field.textContent + ' ' + field.getAttribute('aria-label');
    }

    return value;
  }

  function getFieldText(field, form) {
    var parts = [
      field.getAttribute('data-testid'),
      field.getAttribute('aria-label'),
      field.getAttribute('placeholder'),
      field.getAttribute('name'),
      field.getAttribute('id'),
      getLabelledByText(field)
    ];

    if (field.id && form) {
      var label = query(form, 'label[for="' + cssEscape(field.id) + '"]');
      if (label) {
        parts.push(label.textContent);
      }
    }

    var parentLabel = field.closest('label');
    if (parentLabel) {
      parts.push(parentLabel.textContent);
    }

    return normalize(parts.join(' '));
  }

  function findField(form, selectorList, wordList, fieldSelector) {
    var match = null;

    selectorList.some(function (selector) {
      match = getInputFromMatch(query(form, selector));
      return !!match;
    });

    if (match) {
      return match;
    }

    Array.prototype.some.call(queryAll(form, fieldSelector || 'input, select, textarea, button'), function (field) {
      if (field.type === 'hidden' || field.disabled) {
        return false;
      }

      var text = getFieldText(field, form);
      var found = wordList.some(function (word) {
        return text.indexOf(word) !== -1;
      });

      if (found) {
        match = field;
      }

      return found;
    });

    return match;
  }

  function getErrorColor(field) {
    var root = field && field.getRootNode ? field.getRootNode() : document;
    var host = root && root.host ? root.host : null;
    var colorSource =
      (host && host.closest('[data-forms-errors-color]')) ||
      document.querySelector('[data-forms-errors-color]');

    return (
      colorSource &&
      (colorSource.dataset.formsErrorsColor || colorSource.getAttribute('data-forms-errors-color'))
    ) || '#e02229';
  }

  function getErrorElement(field) {
    var root = field.getRootNode ? field.getRootNode() : document;

    if (!field.id) {
      field.id = 'B2BRegistrationField-' + Math.random().toString(36).slice(2);
    }

    var errorId = field.id + '-EabValidationError';
    var error = query(root, '#' + cssEscape(errorId));

    if (!error) {
      error = document.createElement('p');
      error.id = errorId;
      error.className = 'eab-forms-validation__error';
      error.setAttribute('data-eab-validation-error', '');
      error.style.fontSize = '14px';
      error.style.lineHeight = '1.35';
      error.style.margin = '6px 0 0';
      error.hidden = true;

      if (field.parentNode) {
        field.parentNode.insertBefore(error, field.nextSibling);
      }
    }

    return error;
  }

  function setError(field, message) {
    var error = getErrorElement(field);
    var errorColor = getErrorColor(field);

    if (message) {
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', error.id);
      field.style.borderColor = errorColor;
      if (field.setCustomValidity) {
        field.setCustomValidity(message);
      }
      error.style.color = errorColor;
      error.textContent = message;
      error.hidden = false;
    } else {
      field.removeAttribute('aria-invalid');
      field.removeAttribute('aria-describedby');
      field.style.borderColor = '';
      if (field.setCustomValidity) {
        field.setCustomValidity('');
      }
      error.textContent = '';
      error.hidden = true;
    }
  }

  function validateInvoiceEmail(field) {
    var value = field.value.trim();

    if (!value) {
      setError(field, '');
      return true;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setError(field, messages.invoiceEmail);
      return false;
    }

    setError(field, '');
    return true;
  }

  function isValidOrgNumber(value) {
    var trimmed = value.trim();

    if (!/^\d{6}-?\d{4}$/.test(trimmed)) {
      return false;
    }

    var digits = trimmed.replace('-', '');

    if (digits.length !== 10) {
      return false;
    }

    var sum = 0;

    for (var i = 0; i < 9; i++) {
      var n = parseInt(digits[i], 10);
      if (i % 2 === 0) {
        n *= 2;
      }
      if (n > 9) {
        n -= 9;
      }
      sum += n;
    }

    var controlDigit = parseInt(digits[9], 10);
    return (sum + controlDigit) % 10 === 0;
  }

  function validateOrgNumber(field) {
    if (!field.value.trim()) {
      if (field.required) {
        setError(field, messages.orgNumber);
        return false;
      }

      setError(field, '');
      return true;
    }

    if (!isValidOrgNumber(field.value)) {
      setError(field, messages.orgNumber);
      return false;
    }

    setError(field, '');
    return true;
  }

  function findFieldContainer(field) {
    return field && (
      field.closest('._formFieldContainer_1mxsl_5') ||
      field.closest('._nonMultineFieldLine_exnrn_11') ||
      field.closest('._fieldContainer_exnrn_16') ||
      field.parentElement
    );
  }

  function getFieldLabel(field) {
    var root = field && field.getRootNode ? field.getRootNode() : document;
    var labelledBy = field && field.getAttribute('aria-labelledby');
    var label = null;

    if (labelledBy) {
      labelledBy.split(/\s+/).some(function (id) {
        label = query(root, '#' + cssEscape(id));
        return !!label;
      });
    }

    return label || query(root, 'label[for="' + cssEscape(field.id) + '"]');
  }

  function updateRequiredIndicator(field) {
    var label = field && getFieldLabel(field);

    if (!label) {
      return;
    }

    var indicator = query(label, '[data-eab-required-indicator]');
    var isRequired = (field.required || field.getAttribute('data-eab-required-field') === 'true') && !field.disabled;

    if (!isRequired) {
      if (indicator) {
        indicator.remove();
      }
      return;
    }

    if (!indicator) {
      indicator = document.createElement('span');
      indicator.setAttribute('data-eab-required-indicator', '');
      indicator.setAttribute('aria-hidden', 'true');
      indicator.textContent = ' *';
      label.appendChild(indicator);
    }
  }

  function updateRequiredLegend(legend) {
    if (!legend || query(legend, '[data-eab-required-indicator]')) {
      return;
    }

    var indicator = document.createElement('span');
    indicator.setAttribute('data-eab-required-indicator', '');
    indicator.setAttribute('aria-hidden', 'true');
    indicator.textContent = ' *';
    legend.appendChild(indicator);
  }

  function markConfiguredRequiredFields(form) {
    [
      'company_name',
      'custom#orgnr',
      'first_name',
      'last_name',
      'email',
      'custom#invoice_email'
    ].forEach(function (id) {
      var field = query(form, '[id="' + cssEscape(id) + '"]');

      if (field) {
        field.setAttribute('data-eab-required-field', 'true');
        updateRequiredIndicator(field);
      }
    });

    Array.prototype.forEach.call(queryAll(form, '[id^="billing_address_"], [id^="shipping_address_"]'), function (field) {
      if (field.getAttribute('aria-required') === 'true' || field.required) {
        field.setAttribute('data-eab-required-field', 'true');
        updateRequiredIndicator(field);
      }
    });

    updateRequiredLegend(query(form, 'fieldset[name="custom#har_ert_fretag_ett_existerande_fraktavtal"] legend'));
  }

  function agreementIsTrue(field) {
    if (field && field.type === 'radio') {
      return field.checked && normalize(field.value) === 'true';
    }

    var value = normalize(getFieldValue(field));
    return /(^|\s)(true|yes|ja|y)(\s|$)/.test(value);
  }

  function revealHiddenAncestors(field, form) {
    var node = field && field.parentElement;

    while (node && node !== form) {
      if (node.hidden) {
        node.hidden = false;
      }

      if (node.style && node.style.display === 'none') {
        node.style.display = '';
      }

      node = node.parentElement;
    }
  }

  function setConditionalFieldVisibility(field, visible) {
    var container = findFieldContainer(field);

    if (!field || !container) {
      return;
    }

    if (visible) {
      revealHiddenAncestors(field, field.closest('form'));
    }

    container.hidden = !visible;
    container.style.display = visible ? '' : 'none';
    field.disabled = !visible;
    field.required = visible;
    field.setAttribute('data-eab-conditional-hidden', String(!visible));
    updateRequiredIndicator(field);

    if (!visible) {
      field.value = '';
      setError(field, '');
    }
  }

  function validateRequiredField(field, message) {
    if (!field || !field.required) {
      return true;
    }

    if (!field.value.trim()) {
      setError(field, message);
      return false;
    }

    setError(field, '');
    return true;
  }

  function findShippingCarrierField(form) {
    return findField(form, [
      '[data-testid="field-custom#shipping_carrier"]',
      '#custom\\#shipping_carrier',
      '[id="custom#shipping_carrier"]',
      '[data-testid*="shipping_carrier" i]',
      '[id*="shipping_carrier" i]',
      '[name*="shipping_carrier" i]'
    ], ['shipping carrier', 'fraktleverantor', 'fraktbolag'], 'input, textarea');
  }

  function findGanNumberField(form) {
    return findField(form, [
      '[data-testid="field-custom#gan"]',
      '#custom\\#gan',
      '[id="custom#gan"]',
      '[data-testid="field-custom#gan_nummer"]',
      '#custom\\#gan_nummer',
      '[id="custom#gan_nummer"]',
      '[data-testid="field-custom#gan-nummer"]',
      '#custom\\#gan-nummer',
      '[id="custom#gan-nummer"]'
    ], [], 'input, textarea');
  }

  function findShippingAgreementField(form) {
    return (
      query(form, 'input[name="custom#har_ert_fretag_ett_existerande_fraktavtal"][value="true" i]') ||
      findField(form, [
        'fieldset[name="custom#har_ert_fretag_ett_existerande_fraktavtal"]',
        'fieldset[name="custom#shipping_agreement_in_place"]',
        'button[aria-labelledby*="shipping_agreement_in_place"]',
        'button[aria-labelledby*="shipping-agreement"]',
        '[id="custom#shipping_agreement_in_place-selector-value"]',
        '[data-testid*="shipping_agreement" i]',
        '[id*="shipping_agreement" i]',
        '[name*="shipping_agreement" i]'
      ], ['shipping agreement', 'carrier already', 'fraktavtal'], 'fieldset, button, input, select, textarea')
    );
  }

  function getShippingAgreementRadios(form) {
    return Array.prototype.slice.call(queryAll(form, 'input[name="custom#har_ert_fretag_ett_existerande_fraktavtal"][type="radio"], input[name="custom#shipping_agreement_in_place"][type="radio"]'));
  }

  function setupForm(form) {
    if (!form || initializedForms.indexOf(form) !== -1) {
      return;
    }

    var formRoot = form.getRootNode ? form.getRootNode() : null;
    var formsHost = formRoot && formRoot.host;
    var formsBlock = formsHost && formsHost.closest('[data-forms-id]');

    if (!formsBlock || ['forms-root-1231822', 'forms-root-1089651'].indexOf(formsBlock.getAttribute('data-forms-id')) === -1) {
      return;
    }

    var fields = {
      firstName: findField(form, [
        '[data-testid="field-first_name"]',
        '#first_name',
        '[id="first_name"]'
      ], ['contact first name', 'first name', 'given name'], 'input, textarea'),
      orgNumber: findField(form, [
        '[data-testid="field-custom#orgnr"]',
        '#custom\\#orgnr',
        '[id="custom#orgnr"]',
        '[data-testid="field-company_tax_id"]',
        '#company_tax_id',
        '[id="company_tax_id"]'
      ], [], 'input, textarea'),
      invoiceEmail: findField(form, [
        '[data-testid="field-custom#invoice_email"]',
        '#custom\\#invoice_email',
        '[id="custom#invoice_email"]'
      ], ['invoice email', 'fakturamail', 'fakturamejl'], 'input, textarea'),
      shippingAgreement: findShippingAgreementField(form),
      shippingCarrier: findShippingCarrierField(form),
      ganNumber: findGanNumberField(form)
    };

    if (fields.firstName && !query(form, '[data-eab-contact-person-legend]')) {
      var contactPersonLegend = document.createElement('legend');
      contactPersonLegend.className = '_textBody_2aowh_10';
      contactPersonLegend.setAttribute('data-eab-contact-person-legend', '');
      contactPersonLegend.textContent = messages.contactPerson;

      var firstNameContainer = findFieldContainer(fields.firstName);
      if (firstNameContainer && firstNameContainer.parentNode) {
        firstNameContainer.parentNode.insertBefore(contactPersonLegend, firstNameContainer);
      }
    }

    if (!fields.invoiceEmail && !fields.shippingAgreement) {
      return;
    }

    initializedForms.push(form);
    console.log('[EAB B2B Forms validation] Validation attached', fields);

    if (fields.orgNumber) {
      fields.orgNumber.inputMode = 'numeric';
      fields.orgNumber.required = true;
      updateRequiredIndicator(fields.orgNumber);
    }

    Array.prototype.forEach.call(queryAll(form, 'input[required], select[required], textarea[required]'), updateRequiredIndicator);
    markConfiguredRequiredFields(form);

    if (fields.invoiceEmail && fields.invoiceEmail.tagName === 'INPUT') {
      fields.invoiceEmail.type = 'email';
      fields.invoiceEmail.autocomplete = fields.invoiceEmail.autocomplete || 'email';
    }

    function getDebugFieldState(field) {
      if (!field) {
        return null;
      }

      var validity = field.validity;

      return {
        id: field.id,
        required: field.required,
        disabled: field.disabled,
        valuePresent: !!String(field.value || '').trim(),
        ariaInvalid: field.getAttribute('aria-invalid'),
        valid: typeof field.checkValidity === 'function' ? field.checkValidity() : null,
        validationMessage: field.validationMessage || '',
        validity: validity ? {
          valueMissing: validity.valueMissing,
          typeMismatch: validity.typeMismatch,
          patternMismatch: validity.patternMismatch,
          customError: validity.customError,
          valid: validity.valid
        } : null
      };
    }

    function getFormBlockers() {
      return Array.prototype.reduce.call(queryAll(form, 'input, select, textarea'), function (blockers, field) {
        if (field.disabled || field.type === 'hidden') {
          return blockers;
        }

        var validity = field.validity;
        var invalid = (validity && !validity.valid) || field.getAttribute('aria-invalid') === 'true';

        if (invalid) {
          blockers.push({
            id: field.id,
            name: field.name,
            required: field.required,
            valuePresent: !!String(field.value || '').trim(),
            ariaInvalid: field.getAttribute('aria-invalid'),
            validationMessage: field.validationMessage || '',
            validity: validity ? {
              valueMissing: validity.valueMissing,
              typeMismatch: validity.typeMismatch,
              patternMismatch: validity.patternMismatch,
              customError: validity.customError
            } : null
          });
        }

        return blockers;
      }, []);
    }

    function getRenderedErrorMessages() {
      var messages = [];

      Array.prototype.forEach.call(queryAll(form, '[data-eab-validation-error], [role="alert"], [aria-live="assertive"]'), function (element) {
        var message = String(element.textContent || '').trim();

        if (message && messages.indexOf(message) === -1) {
          messages.push(message);
        }
      });

      return messages;
    }

    function logSubmitState(source, event) {
      console.log('[EAB B2B Forms validation] Submit diagnostic', {
        source: source,
        defaultPrevented: event ? event.defaultPrevented : null,
        formNoValidate: form.noValidate,
        blockingFields: getFormBlockers(),
        renderedErrorMessages: getRenderedErrorMessages(),
        fields: {
          orgNumber: getDebugFieldState(fields.orgNumber),
          invoiceEmail: getDebugFieldState(fields.invoiceEmail),
          shippingAgreement: getDebugFieldState(fields.shippingAgreement),
          shippingCarrier: getDebugFieldState(fields.shippingCarrier),
          ganNumber: getDebugFieldState(fields.ganNumber)
        }
      });
    }

    form.addEventListener('invalid', function (event) {
      console.log('[EAB B2B Forms validation] Native invalid event', {
        id: event.target.id,
        validationMessage: event.target.validationMessage || '',
        validity: event.target.validity
      });
    }, true);

    form.addEventListener('click', function (event) {
      var submitButton = event.target.closest && event.target.closest('[type="submit"]');

      if (submitButton) {
        logSubmitState('submit-button-click', event);
        window.setTimeout(function () {
          logSubmitState('after-submit-button-click');
        }, 0);
        window.setTimeout(function () {
          logSubmitState('after-submit-button-click-100ms');
        }, 100);
      }
    }, true);

    function updateShippingAgreementFields() {
      var visible = agreementIsTrue(fields.shippingAgreement);
      fields.shippingCarrier = fields.shippingCarrier && fields.shippingCarrier.isConnected ? fields.shippingCarrier : findShippingCarrierField(form);
      fields.ganNumber = fields.ganNumber && fields.ganNumber.isConnected ? fields.ganNumber : findGanNumberField(form);
      setConditionalFieldVisibility(fields.shippingCarrier, visible);
      setConditionalFieldVisibility(fields.ganNumber, visible);
      console.log('[EAB B2B Forms validation] Shipping agreement fields updated', {
        visible: visible,
        shippingCarrier: fields.shippingCarrier,
        ganNumber: fields.ganNumber
      });
    }

    if (fields.orgNumber) {
      fields.orgNumber.addEventListener('blur', function () {
        validateOrgNumber(fields.orgNumber);
      });

      fields.orgNumber.addEventListener('input', function () {
        if (fields.orgNumber.getAttribute('aria-invalid') === 'true') {
          validateOrgNumber(fields.orgNumber);
        }
      });
    }

    if (fields.invoiceEmail) {
      fields.invoiceEmail.addEventListener('blur', function () {
        validateInvoiceEmail(fields.invoiceEmail);
      });

      fields.invoiceEmail.addEventListener('input', function () {
        if (fields.invoiceEmail.getAttribute('aria-invalid') === 'true') {
          validateInvoiceEmail(fields.invoiceEmail);
        }
      });
    }

    [
      { field: fields.shippingCarrier, message: messages.shippingCarrier },
      { field: fields.ganNumber, message: messages.ganNumber }
    ].forEach(function (requiredField) {
      if (!requiredField.field) {
        return;
      }

      requiredField.field.addEventListener('blur', function () {
        validateRequiredField(requiredField.field, requiredField.message);
      });

      requiredField.field.addEventListener('input', function () {
        if (requiredField.field.getAttribute('aria-invalid') === 'true') {
          validateRequiredField(requiredField.field, requiredField.message);
        }
      });
    });

    if (fields.shippingAgreement) {
      getShippingAgreementRadios(form).forEach(function (radio) {
        radio.addEventListener('change', updateShippingAgreementFields);
      });

      fields.shippingAgreement.addEventListener('click', function () {
        window.setTimeout(updateShippingAgreementFields, 0);
        window.setTimeout(updateShippingAgreementFields, 150);
      });

      fields.shippingAgreement.addEventListener('change', updateShippingAgreementFields);
      updateShippingAgreementFields();
    }

    form.addEventListener('submit', function (event) {
      logSubmitState('submit-event', event);
      var invalidFields = [];

      if (fields.orgNumber && !validateOrgNumber(fields.orgNumber)) {
        invalidFields.push(fields.orgNumber);
      }

      if (fields.invoiceEmail && !validateInvoiceEmail(fields.invoiceEmail)) {
        invalidFields.push(fields.invoiceEmail);
      }

      if (fields.shippingCarrier && !validateRequiredField(fields.shippingCarrier, messages.shippingCarrier)) {
        invalidFields.push(fields.shippingCarrier);
      }

      if (fields.ganNumber && !validateRequiredField(fields.ganNumber, messages.ganNumber)) {
        invalidFields.push(fields.ganNumber);
      }

      if (invalidFields.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        logSubmitState('blocked-by-eab-validation', event);
        invalidFields[0].focus();
      }
    }, true);
  }

  function initFormsValidation() {
    getSearchRoots().forEach(function (root) {
      Array.prototype.forEach.call(queryAll(root, 'form'), setupForm);
    });
  }

  function scheduleInit() {
    window.clearTimeout(scheduleTimer);
    scheduleTimer = window.setTimeout(initFormsValidation, 200);
  }

  function observeRoot(root) {
    if (!root || !root.querySelectorAll || observedRoots.indexOf(root) !== -1) {
      return;
    }

    observedRoots.push(root);

    var observer = new MutationObserver(function () {
      initFormsValidation();
      initializedForms.forEach(function (form) {
        var agreement = findShippingAgreementField(form);

        if (agreement) {
          var carrier = findShippingCarrierField(form);
          var gan = findGanNumberField(form);
          var visible = agreementIsTrue(agreement);
          setConditionalFieldVisibility(carrier, visible);
          setConditionalFieldVisibility(gan, visible);
        }

        markConfiguredRequiredFields(form);
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function observeFormsEmbed() {
    getFormsEmbeds().forEach(function (embed) {
      observeRoot(embed);

      if (embed.shadowRoot) {
        observeRoot(embed.shadowRoot);
      }
    });

    scheduleInit();
  }

  function start() {
    var style = document.createElement('style');
    style.textContent = [
      '.eab-forms-validation__error { color: #c20000; font-size: 14px; line-height: 1.35; margin: 6px 0 0; }',
      '[aria-invalid="true"] { border-color: #c20000 !important; }'
    ].join('');
    document.head.appendChild(style);

    observeFormsEmbed();

    var docObserver = new MutationObserver(observeFormsEmbed);
    docObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    [500, 1500, 3000, 6000, 12000].forEach(function (delay) {
      window.setTimeout(observeFormsEmbed, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
